import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';

export default {
  props: {
    isOnList: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('list', ['getProductsIdsInLists', 'getProductsIdsInDefaultLists']),
    ...mapState('list', [
      'defaultShoppingList',
      'shoppingLists',
      'isShoppingListLoading',
      'shoppingListsTypes',
      'shoppingListCycles',
    ]),
  },
  methods: {
    ...mapMutations({
      pushModal: 'modal/pushModal',
    }),
    ...mapActions({
      toggleProductFromList: 'list/toggleProductFromList',
      getShoppingLists: 'list/getShoppingLists',
      addProductsToShoppingList: 'list/addProductsToShoppingList',
      addProductToShoppingList: 'list/addProductToShoppingList',
      deleteProductFromShoppingList: 'list/deleteProductFromShoppingList',
      openNewListModal: 'list/openNewListModal',
      getShoppingListsTypes: 'list/getShoppingListsTypes',
      getShoppingListsCycles: 'list/getShoppingListsCycles',
      addNewShoppingList: 'list/addNewShoppingList',
      updateNewShoppingList: 'list/updateNewShoppingList',
      deleteShoppingList: 'list/deleteShoppingList',
      addShoppingListToBasket: 'list/addShoppingListToBasket',
      deleteProductsFromShoppingList: 'list/deleteProductsFromShoppingList',
      openModalAddShoppingListToBasket: 'list/openModalAddShoppingListToBasket',
    }),
    findProductsInList(ids, list) {
      if (!ids?.length) return false;
      const itemIds = new Set(list.items.map(({ item }) => item.id));
      return ids.every(id => itemIds.has(id));
    },
    findProductInList(id, list) {
      if (!id) return false;
      return !!list?.items.find(product => {
        return product.item.id === id;
      });
    },
    checkIfInList(id) {
      if (this.$auth.isLogged()) {
        return !!this.getProductsIdsInLists.find(productId => {
          return productId === id;
        });
      } else {
        return !!this.getProductsIdsInDefaultLists.find(productId => {
          return productId === id;
        });
      }
    },
  },
};
